module.exports = __webpack_public_path__ + "img/Meeting-text.20ef738f.jpg";